import { defaultAggProps } from "./index60.js";
import { getSubdivisionRatio } from "./index74.js";
import { isValidSubdivision } from "./index75.js";
import { SplitPolyByBBox } from "./index77.js";
import { Vector3toV3, getPolygonArea, randomItem } from "@project-rouge/rg-three";
var splitLikelihoodHigher = .3;
var splitLikelihoodLower = .01;
let SplitDirection = /* @__PURE__ */ function(SplitDirection$1) {
	SplitDirection$1[SplitDirection$1["transverse"] = 0] = "transverse";
	SplitDirection$1[SplitDirection$1["longitudinal"] = 1] = "longitudinal";
	return SplitDirection$1;
}({});
function recursiveSubdivision({ poly, maxCount = defaultAggProps.maxPlotCount, minWidth = defaultAggProps.minWidth, maxLength = defaultAggProps.maxLength, minArea = defaultAggProps.minArea, allowLongitudinalSplit = defaultAggProps.allowLongitudinalSplit, rng }) {
	const splitRatioOptions = [
		.5,
		.333,
		.667
	];
	let splitDirectionOptions;
	if (allowLongitudinalSplit) splitDirectionOptions = [SplitDirection.transverse, SplitDirection.longitudinal];
	else splitDirectionOptions = [SplitDirection.transverse];
	const allValidOptions = splitRatioOptions.flatMap((o) => splitDirectionOptions.map((d) => getSubdivisionRatio(o, d)));
	let validOptions = allValidOptions.slice();
	const data = {
		polygon: poly.slice(),
		children: []
	};
	const root = data;
	const queue = [];
	queue.push(data);
	let count = 1;
	const splitLikelihood = rng && rng() > .5 ? splitLikelihoodHigher : splitLikelihoodLower;
	while (queue.length > 0) {
		if (validOptions.length === 0) break;
		if (count + 1 > maxCount) break;
		let wasPolygonSplit = false;
		queue.sort((a, b) => getPolygonArea(a.polygon.map((v) => v.slice())) - getPolygonArea(b.polygon.map((v) => v.slice())));
		const biggestPoly = queue[queue.length - 1];
		while (validOptions.length > 0) {
			const splitOption = randomItem({
				list: validOptions,
				rng
			});
			validOptions.splice(validOptions.findIndex((v) => v === splitOption), 1);
			if (isValidSubdivision({
				polygon: biggestPoly.polygon,
				splitOption,
				maxLength,
				minWidth,
				minArea,
				maxCount,
				rng,
				count,
				splitLikelihood
			})) {
				queue.pop();
				const temp = SplitPolyByBBox(biggestPoly.polygon, splitOption.ratio, splitOption.direction).map((p) => p.map(Vector3toV3));
				const newData = [];
				for (const p of temp) newData.push({
					polygon: p,
					children: []
				});
				biggestPoly.ratio = splitOption.ratio;
				biggestPoly.splitDirection = splitOption.direction;
				biggestPoly.children.push(...newData);
				queue.push(...newData);
				count++;
				wasPolygonSplit = true;
				break;
			}
		}
		if (wasPolygonSplit === false) queue.pop();
		validOptions = allValidOptions.slice();
	}
	return {
		polygons: getLeafPolygons(root),
		root
	};
}
function getLeafPolygons(divisionData) {
	const polygons = [];
	if (divisionData.children.length === 0) polygons.push(divisionData.polygon);
	else for (const d of divisionData.children) polygons.push(...getLeafPolygons(d));
	return polygons;
}
export { SplitDirection, recursiveSubdivision };

//# sourceMappingURL=index76.js.map